<template>
  <div class="settle-manager">
    <el-table :data="list"
              style="width: 100%"
              tooltip-effect="light"
              border
              resizable>
      <el-table-column prop="adjustNo"
                       label="调整单号"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="itemName"
                       label="物料名称"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="itemCode"
                       label="物料编码"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="beforeAdjustNum"
                       label="调前数量(吨)"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="adjustNum"
                       label="调整数量(吨)"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="afterAdjustNum"
                       label="调后数量(吨)"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="createTime"
                       label="调整时间"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="adjustType"
                       label="业务类型"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          {{
            scope.row.adjustType === 'ADJUST'
              ? '库存调整'
              : scope.row.adjustType === 'ADJUST_IN'
              ? '库存调增'
              : scope.row.adjustType === 'ADJUST_DE'
              ? '库存调减'
              : ''
          }}
        </template>
      </el-table-column>
      <el-table-column prop="reservoirAreaCode"
                       label="库区编码"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="reservoirAreaName"
                       label="库区名称"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="storeroomCode"
                       label="库房"
                       show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="storeroomName"
                       label="库房名称"
                       show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="oilTankCode"
                       label="料堆"
                       show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="oilTankName"
                       label="料堆名称"
                       show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="businessUser"
                       label="业务人"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="reason"
                       label="原因说明"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="file"
                       label="附件信息"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button v-if="scope.row.file"
                     @click="handleDownload(scope.row.file)">下载附件
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :page-sizes="[10, 20, 50, 100]"
                   :page-size="listState.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="listState.total"
                   :current-page="listState.pageNo"
                   background
                   @current-change="handleCurrentChange"
                   @size-change="handleSizeChange">
    </el-pagination>
    <el-row class="export-row"
            type="flex"
            justify="end">
      <el-button type="primary"
                 @click="handleExportCSV">导出为CSV文件</el-button>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'inventoryCollectAdjust',
  data () {
    return {
      form: {},
      dialogVisible: false,
      printDialogInfo: {},
      reservoirAreaOptions: [],
      oilTankOptions: [],
      options: [
        {
          value: 'ADJUST',
          label: '库存调整'
        },
        {
          value: 'ADJUST_IN',
          label: '库存调增'
        },
        {
          value: 'ADJUST_DE',
          label: '库存调减'
        }
      ],
      formOilTankOptions: [],
      oilTankData: []
    }
  },
  computed: {
    ...mapGetters({
      list: 'getInventoryAdjustList',
      listState: 'getInventoryAdjustListState'
    }),
    ...mapState({
      adjustParams: (state) => state.cache.adjustParams
    })
  },
  methods: {
    ...mapActions(['getInventoryAdjust', 'exportInventoryAdjustmentSheet']),
    handleOpen (row) { },
    // 搜索
    handleSearch () {
      const { reservoirAreaCode, oilTankCode, timeStart, timeEnd } = this.adjustParams
      const payload = {
        reservoirAreaCode,
        oilTankCode,
        adjustDateStart: timeStart,
        adjustDateEnd: timeEnd
      }
      this.getInventoryAdjust(payload)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getInventoryAdjust({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getInventoryAdjust({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 格式化状态
    formatStatus (row) {
      const status =
        this.$lodash.find(this.statusArr, { value: row.qyStatus }) || {}
      return status.label
    },
    handleDownload (fileUrl) {
      window.open(fileUrl, '_blank')
    },
    changeReservoirArea (val) {
      this.getDicOilTankList(val ? { reservoirAreaName: val } : {}).then(
        (res) => {
          if (res) {
            this.formOilTankOptions = res.map((item) => {
              return {
                oilTankCode: item.oilTankCode,
                oilTankName: item.oilTankName
              }
            })
          }
        }
      )
    },
    handleExportCSV () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const { reservoirAreaCode, oilTankCode, timeStart, timeEnd } = this.adjustParams
          const payload = {
            reservoirAreaCode,
            oilTankCode,
            adjustDateStart: timeStart,
            adjustDateEnd: timeEnd
          }
          this.exportInventoryAdjustmentSheet({
            ...payload,
            pageNo: this.listState.pageNo,
            pageSize: this.listState.pageSize
          }).then((res) => {
            function createDownloadFile () {
              let blob = new Blob([res])
              let link = document.createElement('a')
              link.download = '库存调整列表.xls'
              link.style.display = 'none'
              link.target = '_Blank'
              link.href = window.URL.createObjectURL(blob)
              document.body.appendChild(link)
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
            createDownloadFile()
            this.$message.success('导出成功')
          })
        })
        .catch((e) => { })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>
.export-row {
  margin-top: 10px;
}
</style>
